import { fetchGetAllBillingDetails } from '@/api/billing'

const billing = {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    GetAllBillingDetails(state, data) {
      return fetchGetAllBillingDetails(data)
    },
  },
}

export default billing
